exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-48d6e8bc] .expired {\r\n    color: red;\n}\n[data-v-48d6e8bc] .expiringSoon {\r\n    color: orange;\n}\r\n", ""]);

// exports
